module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ]
    }
  },
  "/api": {
    "name": "api",
    "success": {
      "default": [
        "API_PAGE_LOAD"
      ]
    },
    "error": [
      "API_PAGE_ERROR"
    ]
  },
  "/custom": {
    "name": "custom",
    "success": {
      "default": [
        "CUSTOM_PAGE_LOAD"
      ]
    },
    "error": [
      "CUSTOM_PAGE_ERROR"
    ]
  }
};